module.exports = __webpack_public_path__ + "img/03.ab1ce714.png";